import { AppState } from 'reducers'

const root = (state: AppState) => state.location

export const locale = (state: AppState) => ({
  country: state.location.country,
  language: state.location.language,
})

export const geoCoordinates = (state: AppState) => state.location.geoCoordinates

export const radius = (state: AppState) => state.location.radius

export const limit = (state: AppState) => state.location.limit

export default root
